/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { domContainerFactory as t } from "../../utils.mjs";
import { canUseDOM as p } from "@progress/kendo-react-common";
class H {
  constructor() {
    this.itemHeight = 0, this.timeListHeight = 0, this.didCalculate = !1;
  }
  ensureHeights() {
    this.timeListHeight === void 0 && this.calculateHeights();
  }
  calculateHeights(s) {
    if (!p)
      return;
    const e = t("div"), r = t("span"), l = t("ul"), n = t("li"), c = () => n("<span>02</span>", "k-item"), a = () => l([c()], "k-reset"), m = () => e([a()], "k-content k-scrollable k-time-container"), h = e(
      [
        r("minute", "k-title"),
        e([m()], "k-time-list")
      ],
      "k-time-list-wrapper",
      { left: "-10000px", position: "absolute" }
    ), o = s && s.querySelector(".k-time-container") || document.body, i = o.appendChild(h);
    this.timeListHeight = i.querySelector(".k-scrollable").offsetHeight, this.itemHeight = i.querySelector("li").offsetHeight, o.removeChild(i), this.didCalculate = !0;
  }
}
export {
  H as DOMService
};
